import { actions } from './dashboard/actions'
import { getters } from './dashboard/getters'
import { state } from './dashboard/state'
import { mutations } from './dashboard/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
